import { render } from "./App.vue?vue&type=template&id=c1e60cbe"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c1e60cbe&lang=css"

import exportComponent from "C:\\Users\\guido\\OneDrive\\Documents\\FILES\\Systems\\CTS\\new frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__